import { makeStyles } from 'tss-react/mui';

const useOverviewCardStyles = makeStyles()((theme) => ({
  title: {
    color: theme.new.color.text.primary,
  },
  secondary: {
    color: theme.new.color.text.secondary,
  },
  tooltipIcon: {
    '&&': {
      padding: 0,
    },
    '& svg': {
      width: 16,
      height: 16,
    },
    '& svg path': {
      stroke: theme.new.color.text.secondary,
    },
  },
}));

export default useOverviewCardStyles;
